// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"342def80","499":"2c402509","503":"cd1f58dd","573":"977a036b","642":"4c7cac15"}[chunkId] + ".chunk.css";
};